// extracted by mini-css-extract-plugin
export var logo = "_bo-2";
export var logoWrapper = "_bo-1";
export var strip = "_bo-0";